module.exports = __webpack_public_path__ + "static/d-a-v-i-d-s-o-n-l-u-n-a-mhTUlFub1vU-unsplash-11571e125d3c2c82c3c94dad4a1e4cf8.png";